module.exports = __webpack_public_path__ + "static/media/Sandra P.c127db92.png";